//angular
import { Component, EventEmitter, OnInit, Output, ViewChild, ElementRef, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { GridService } from 'src/app/_core/services';
import { VisibleState, CheckboxState } from '../../../../app.data';
import { MetaService } from 'src/app/_core/services/meta.service';

@Component({
  selector: 'panel-grid-search',
  templateUrl: './panel-grid-search.component.html',
  // animations: [panelPreferences]
})

export class PanelGridSearchComponent implements OnInit {
  status: boolean = false;
  statusPanel: string = 'isHidden';

  @Input() _inputSearchPlaceholder: string;
  @Input() _preSetInputText: string;

  @Output()
  onSetDefaultValues: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onGetGridData: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('inputSearch') _elemInputSearch: ElementRef;

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    public _meta: MetaService,
    public _grid: GridService,
  ) {
    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
    this._iconRegistry.addSvgIcon('ico-drag', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-drag-02.svg'));
  }

  ngOnInit() {
  }

  onClearSearchInput() {
    this.onSetDefaultValues.emit();

    if (this._grid.statusSnackBar == VisibleState.isVisible) {
      this._grid.closeBulkDialog();
    }

    this.onGetGridData.emit();
  }

  async onSearchInputKeyup(_event, _searchQuery: string) {
    this._grid.bulkIsChecked = false;
    this._grid.bulkIsIndeterminate = false;
    this._grid.checkedCount = 0;
    this._grid.statusBulkCheckbox = CheckboxState.uncheck;

    if (this._grid.statusSnackBar == VisibleState.isVisible) {
      this._grid.closeBulkDialog();
    }

    for (const value of Object.values(this._grid.collectionOfGridItems)) {
      value['checked'] = this._grid.bulkIsChecked;
    }

    this._grid.inputSearchIsValid = (_searchQuery !== '' ? true : false);
    if (_event.key === 'Enter') {
      this._grid.searchQuery = _searchQuery;
      await this._grid.updateQueryParams(null, null, this._grid.searchQuery, null)
      this.onGetGridData.emit();
    }
  }
}
